<script lang="ts" setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { AdjustmentsHorizontalIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const menuOpen = ref(false);
</script>

<template>
  <div>
    <!-- Mobile Filters Button -->
    <div>
      <button
        class="hover:text-ph-green-600 focus:outline-ph-green-600 2xs:focus:outline-offset-1 flex cursor-pointer rounded-md p-2 text-base/7 font-medium text-gray-700 focus:outline-2 focus:outline-offset-3"
        type="button"
        @click="menuOpen = true"
      >
        <AdjustmentsHorizontalIcon class="2xs:h-7 2xs:w-7 h-6 w-6" />
        <span class="xs:block hidden pl-2">{{ t('views.search.filters') }}</span>
      </button>
    </div>

    <!-- Mobile Filters Dialog -->
    <TransitionRoot :show="menuOpen" as="template">
      <Dialog class="relative z-40 lg:hidden" @close="menuOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100" leave-to="opacity-0">
          <div class="fixed inset-0 bg-black/25" />
        </TransitionChild>

        <div class="fixed inset-0 z-40 flex">
          <TransitionChild
            as="template"
            enter="transition ease-in-out duration-300 transform"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leave-from="translate-x-0"
            leave-to="translate-x-full"
          >
            <DialogPanel class="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white shadow-xl">
              <div class="flex items-center justify-between border-b border-gray-200 py-2 pr-2 pl-4">
                <h2 class="text-lg font-medium text-gray-900">
                  {{ t('views.search.filters') }}
                </h2>
                <button class="focus:outline-ph-green-600 hover:text-ph-green-600 flex h-10 w-10 cursor-pointer items-center justify-center rounded-md p-2 text-gray-400" type="button" @click="menuOpen = false">
                  <span class="sr-only">Close menu</span>
                  <XMarkIcon aria-hidden="true" class="h-6 w-6" />
                </button>
              </div>
              <div class="px-2 pt-2 pb-12">
                <slot></slot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<style lang="css" scoped></style>
